import React from 'react'
import { Button, Table } from 'antd'
import { ColumnProps } from 'antd/es/table'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { EditOutlined } from '@ant-design/icons'
import { CustomExchangeRateSeriesWithCompany } from '../types/exchangeRate'
import { useExchangeRates } from '..'
import { Loading } from '../../../components/Misc/Loading'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'

const ExchangeRateTable = () => {
  const { t } = useTranslation()
  const { companyId } = useContextParameters()

  const { data: exchangeRates, isPending: exchangeRatesPending, isLoading: exchangeRatesLoading } = useExchangeRates()

  const columns: ColumnProps<CustomExchangeRateSeriesWithCompany>[] = [
    {
      dataIndex: ['company', 'name'],
      title: t('global:company'),
      render(value) {
        if (!value) {
          return t('errorMessage:COMPANY_UNAUTHORIZED')
        }
        return value
      }
    },
    {
      dataIndex: 'currency',
      title: t('global:currency'),
      render(currency, { baseCurrency }) {
        return `${currency}/${baseCurrency}`
      }
    },
    {
      dataIndex: 'edit',
      width: 80,
      title: t('global:actions'),
      render: (value, record) => {
        if (!record.company?.name) return null
        return (
          <Link to="/settings/company/group/exchangeRate/edit" state={{ record, contextCompanyId: companyId }}>
            <Button type="text" icon={<EditOutlined />} />
          </Link>
        )
      }
    }
  ]

  if (exchangeRatesPending) return <Loading />

  return <Table loading={exchangeRatesLoading} size="small" rowKey="id" columns={columns} dataSource={exchangeRates} />
}

export default ExchangeRateTable
